
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blacknovember",
      function () {
        return require("private-next-pages/blacknovember.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blacknovember"])
      });
    }
  